import React, { useEffect } from 'react';
import './Design.css';
// import '@coreui/coreui/dist/css/coreui.min.css';
import Button from 'react-bootstrap/Button';
import { CCarousel, CCarouselItem } from '@coreui/react';
import { BsArrowRight } from "react-icons/bs";

function Design() {

    const buttonSelect = () => {
        let buttons = document.querySelectorAll(".btn");
        let sub_buttons_container = document.querySelectorAll(".gallery-sub-headers-button-container");
        let sub_buttons = document.querySelectorAll(".sub-btn");
        let carousels = document.querySelectorAll(".custom-carousel");
        let view_all = document.querySelectorAll(".view-all-container");

        sub_buttons[0].classList.add("active-now");
        sub_buttons[3].classList.add("active-now");
        sub_buttons[7].classList.add("active-now");
        sub_buttons[1].classList.remove("active-now");
        sub_buttons[2].classList.remove("active-now");
        sub_buttons[4].classList.remove("active-now");
        sub_buttons[5].classList.remove("active-now");
        sub_buttons[6].classList.remove("active-now");
        sub_buttons[8].classList.remove("active-now");
        sub_buttons[9].classList.remove("active-now");
        
        for(let i = 0; i<buttons.length; i++) {
            buttons[i].addEventListener('click', () => {
                console.log(i);
                if (i === 0) {
                    document.querySelector(".gallery-sub-headers-container").classList.remove("right");
                    buttons[0].classList.add("active-now");
                    buttons[1].classList.remove("active-now");
                    buttons[2].classList.remove("active-now");
                    buttons[3].classList.remove("active-now");
                    sub_buttons_container[0].classList.add("display");
                    sub_buttons_container[1].classList.remove("display");
                    sub_buttons_container[2].classList.remove("display");
                    view_all[0].classList.add("display");
                    view_all[1].classList.remove("display");
                    view_all[2].classList.remove("display");
                    view_all[3].classList.remove("display");
                    carousels[0].classList.add("display");
                    carousels[1].classList.add("display");
                    carousels[2].classList.add("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 1) {
                    document.querySelector(".gallery-sub-headers-container").classList.remove("right");
                    buttons[0].classList.remove("active-now");
                    buttons[1].classList.add("active-now");
                    buttons[2].classList.remove("active-now");
                    buttons[3].classList.remove("active-now");
                    sub_buttons_container[0].classList.remove("display");
                    sub_buttons_container[1].classList.add("display");
                    sub_buttons_container[2].classList.remove("display");
                    view_all[0].classList.remove("display");
                    view_all[1].classList.add("display");
                    view_all[2].classList.remove("display");
                    view_all[3].classList.remove("display");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.add("display");
                    carousels[10].classList.add("display");
                    carousels[11].classList.add("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 2) {
                    document.querySelector(".gallery-sub-headers-container").classList.remove("right");
                    buttons[0].classList.remove("active-now");
                    buttons[1].classList.remove("active-now");
                    buttons[2].classList.add("active-now");
                    buttons[3].classList.remove("active-now");
                    sub_buttons_container[0].classList.remove("display");
                    sub_buttons_container[1].classList.remove("display");
                    sub_buttons_container[2].classList.add("display");
                    view_all[0].classList.remove("display");
                    view_all[1].classList.remove("display");
                    view_all[2].classList.add("display");
                    view_all[3].classList.remove("display");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.add("display");
                    carousels[22].classList.add("display");
                    carousels[23].classList.add("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 3) {
                    document.querySelector(".gallery-sub-headers-container").classList.add("right");
                    buttons[0].classList.remove("active-now");
                    buttons[1].classList.remove("active-now");
                    buttons[2].classList.remove("active-now");
                    buttons[3].classList.add("active-now");
                    sub_buttons_container[0].classList.remove("display");
                    sub_buttons_container[1].classList.remove("display");
                    sub_buttons_container[2].classList.remove("display");
                    view_all[0].classList.remove("display");
                    view_all[1].classList.remove("display");
                    view_all[2].classList.remove("display");
                    view_all[3].classList.add("display");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.add("display");
                    carousels[31].classList.add("display");
                    carousels[32].classList.add("display");
                }
            })
        }
    }

    const subButtonSelect = () => {
        let sub_buttons = document.querySelectorAll(".sub-btn");
        let carousels = document.querySelectorAll(".custom-carousel");

        for(let i = 0; i<sub_buttons.length; i++) {
            sub_buttons[i].addEventListener('click', () => {
                if (i === 0) {
                    sub_buttons[0].classList.add("active-now");
                    sub_buttons[1].classList.remove("active-now");
                    sub_buttons[2].classList.remove("active-now");
                    carousels[0].classList.add("display");
                    carousels[1].classList.add("display");
                    carousels[2].classList.add("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 1) {
                    sub_buttons[0].classList.remove("active-now");
                    sub_buttons[1].classList.add("active-now");
                    sub_buttons[2].classList.remove("active-now");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.add("display");
                    carousels[4].classList.add("display");
                    carousels[5].classList.add("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 2) {
                    sub_buttons[0].classList.remove("active-now");
                    sub_buttons[1].classList.remove("active-now");
                    sub_buttons[2].classList.add("active-now");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.add("display");
                    carousels[7].classList.add("display");
                    carousels[8].classList.add("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 3) {
                    sub_buttons[3].classList.add("active-now");
                    sub_buttons[4].classList.remove("active-now");
                    sub_buttons[5].classList.remove("active-now");
                    sub_buttons[6].classList.remove("active-now");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.add("display");
                    carousels[10].classList.add("display");
                    carousels[11].classList.add("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 4) {
                    sub_buttons[3].classList.remove("active-now");
                    sub_buttons[4].classList.add("active-now");
                    sub_buttons[5].classList.remove("active-now");
                    sub_buttons[6].classList.remove("active-now");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.add("display");
                    carousels[13].classList.add("display");
                    carousels[14].classList.add("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 5) {
                    sub_buttons[3].classList.remove("active-now");
                    sub_buttons[4].classList.remove("active-now");
                    sub_buttons[5].classList.add("active-now");
                    sub_buttons[6].classList.remove("active-now");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.add("display");
                    carousels[16].classList.add("display");
                    carousels[17].classList.add("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 6) {
                    sub_buttons[3].classList.remove("active-now");
                    sub_buttons[4].classList.remove("active-now");
                    sub_buttons[5].classList.remove("active-now");
                    sub_buttons[6].classList.add("active-now");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.add("display");
                    carousels[19].classList.add("display");
                    carousels[20].classList.add("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 7) {
                    sub_buttons[7].classList.add("active-now");
                    sub_buttons[8].classList.remove("active-now");
                    sub_buttons[9].classList.remove("active-now");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.add("display");
                    carousels[22].classList.add("display");
                    carousels[23].classList.add("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 8) {
                    sub_buttons[7].classList.remove("active-now");
                    sub_buttons[8].classList.add("active-now");
                    sub_buttons[9].classList.remove("active-now");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.add("display");
                    carousels[25].classList.add("display");
                    carousels[26].classList.add("display");
                    carousels[27].classList.remove("display");
                    carousels[28].classList.remove("display");
                    carousels[29].classList.remove("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                } else if (i === 9) {
                    sub_buttons[7].classList.remove("active-now");
                    sub_buttons[8].classList.remove("active-now");
                    sub_buttons[9].classList.add("active-now");
                    carousels[0].classList.remove("display");
                    carousels[1].classList.remove("display");
                    carousels[2].classList.remove("display");
                    carousels[3].classList.remove("display");
                    carousels[4].classList.remove("display");
                    carousels[5].classList.remove("display");
                    carousels[6].classList.remove("display");
                    carousels[7].classList.remove("display");
                    carousels[8].classList.remove("display");
                    carousels[9].classList.remove("display");
                    carousels[10].classList.remove("display");
                    carousels[11].classList.remove("display");
                    carousels[12].classList.remove("display");
                    carousels[13].classList.remove("display");
                    carousels[14].classList.remove("display");
                    carousels[15].classList.remove("display");
                    carousels[16].classList.remove("display");
                    carousels[17].classList.remove("display");
                    carousels[18].classList.remove("display");
                    carousels[19].classList.remove("display");
                    carousels[20].classList.remove("display");
                    carousels[21].classList.remove("display");
                    carousels[22].classList.remove("display");
                    carousels[23].classList.remove("display");
                    carousels[24].classList.remove("display");
                    carousels[25].classList.remove("display");
                    carousels[26].classList.remove("display");
                    carousels[27].classList.add("display");
                    carousels[28].classList.add("display");
                    carousels[29].classList.add("display");
                    carousels[30].classList.remove("display");
                    carousels[31].classList.remove("display");
                    carousels[32].classList.remove("display");
                }
            })
        }
    }

    useEffect(() => {
        buttonSelect();
        subButtonSelect();
    })

    return (
        <div className='design-main-container tag' id='design'>
            <div className='main-content-container'>
                <div className='design-content-head display'>
                    <div className='head-title-1'>
                        DESIGN
                    </div>
                    <div className='head-title-2'>
                        YOUR HOME YOUR STYLE                    
                    </div>
                </div>
                <div className='gallery-headers-button-container'>
                    <Button className='active-now' onClick={buttonSelect}>Bedroom</Button>
                    <Button onClick={buttonSelect}>Living Room</Button>
                    <Button onClick={buttonSelect}>Kitchen</Button>
                    <Button onClick={buttonSelect}>Other</Button>
                </div>
                <div className='gallery-sub-headers-container'>
                    <div className='gallery-sub-headers-button-container display'>
                        <span className='sub-btn active-now' onClick={subButtonSelect}>Master</span>
                        <span className='sub-btn' onClick={subButtonSelect}>Guest</span>
                        <span className='sub-btn' onClick={subButtonSelect}>Kids</span>
                    </div>
                    <div className='view-all-container display'>
                        <span><a href="/bedroom">View All</a></span>
                        <BsArrowRight />
                    </div>
                    <div className='gallery-sub-headers-button-container'>
                        <span className='sub-btn active-now' onClick={subButtonSelect}>Home Decor</span>
                        <span className='sub-btn' onClick={subButtonSelect}>False Ceiling and Lighting</span>
                        <span className='sub-btn' onClick={subButtonSelect}>Foyer Area</span>
                        <span className='sub-btn' onClick={subButtonSelect}>TV Unit</span>
                    </div>
                    <div className='view-all-container'>
                        <span><a href="/living-room">View All</a></span>
                        <BsArrowRight />
                    </div>
                    <div className='gallery-sub-headers-button-container'>
                        <span className='sub-btn active-now' onClick={subButtonSelect}>Dining</span>
                        <span className='sub-btn' onClick={subButtonSelect}>Modular Kitchen</span>
                        <span className='sub-btn' onClick={subButtonSelect}>Crockery Unit</span>
                    </div>
                    <div className='view-all-container'>
                        <span><a href="/kitchen">View All</a></span>
                        <BsArrowRight />
                    </div>
                    <div className='view-all-container'>
                        <span><a href="/others">View All</a></span>
                        <BsArrowRight />
                    </div>
                </div>

                {/* Bedroom Carousels */}

                {/* Master Bedrrom Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel display home-normal">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/1.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/2.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/3.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/4.jpg")} alt="image1" /> 
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/5.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/6.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/7.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/8.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel display home-tablet">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/1.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/2.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/3.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/4.jpg")} alt="image1" /> 
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/5.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/6.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/7.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/8.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel display home-mobile">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/1.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/2.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/3.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/4.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/5.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/6.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/7.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Master Bedroom/8.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* Guest Bedroom Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0007.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0008.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0009.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0010.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0011.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0012.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0007.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0008.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0009.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0010.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0011.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0012.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0007.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0008.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0009.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0010.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0011.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Guest Bedroom/IMG-20220919-WA0012.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* Kids Bedroom Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/1.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/2.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/3.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/4.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/5.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/6.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/7.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/8.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/1.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/2.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/3.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/4.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/5.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/6.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/7.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/8.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/1.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/2.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/3.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/4.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/5.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/6.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/7.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Kids Bedroom/8.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* Living Room Carousels */}

                {/* Home Decor Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/1.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/2.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/3.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/4.jpg")} alt="image1" /> 
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/5.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/6.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/7.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/8.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel con  trols transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/1.jpg")} alt="image1" /> 
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/2.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/3.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/4.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/5.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/6.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/7.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/8.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/1.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/2.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/3.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/4.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/5.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/6.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/7.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Home Decor/8.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* False Ceiling Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/1.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/2.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/3.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/4.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/5.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/6.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/7.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/8.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/1.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/2.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/3.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/4.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/5.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/6.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/7.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/8.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/1.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/2.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/3.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/4.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/5.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/6.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/7.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/8.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* Foyer Area Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0148.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0149.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0150.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0151.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0152.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0153.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0154.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0155.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0148.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0149.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0150.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0151.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0152.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0153.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0154.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0155.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0148.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0149.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0150.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0151.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0152.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0153.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0154.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Foyer Area/IMG-20220919-WA0155.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* TV Unit Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.13 AM (1).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.13 AM (2).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.13 AM (3).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM.jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (1).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (2).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (3).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (4).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.13 AM (1).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.13 AM (2).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.13 AM (3).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM.jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (1).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (2).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (3).jpeg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (4).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.13 AM (1).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.13 AM (2).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.13 AM (3).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM.jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (1).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (2).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (3).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Tv Unit/WhatsApp Image 2022-09-20 at 9.30.14 AM (4).jpeg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* Kitchen Carousels */}

                {/* Dining Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0067.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0068.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0069.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0070.jpg")} alt="image1" /> 
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0071.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0072.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0073.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0074.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0067.jpg")} alt="image1" /> 
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0068.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0069.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0070.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0071.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0072.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0073.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0074.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0067.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0068.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0069.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0070.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0071.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0072.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0073.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Dining Area/IMG-20220919-WA0074.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* Modular Kitchen Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0131.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0132.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0133.jpg")} alt="image1" />
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0134.jpg")} alt="image1" />
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0135.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0115.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0137.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0138.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0131.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0132.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0133.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0134.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0135.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0115.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0137.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0138.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0131.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0132.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0133.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0134.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0135.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0115.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0137.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Modular Kitchen/IMG-20220919-WA0138.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* Crockery Unit Carousel */}
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0140.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0141.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0142.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0143.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0140.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0141.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0142.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0143.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/1.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/1.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/False Ceiling and Lighting/1.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0140.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0141.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0142.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Crockery Unit/IMG-20220919-WA0143.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>

                {/* Other Carousels */}

                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-normal">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0160.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0161.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0162.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0163.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className="carousel-contain">
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0164.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0165.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0166.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0167.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-tablet">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0160.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0161.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0162.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0163.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0164.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0165.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0166.jpg")} alt="image1" />    
                            </div>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0167.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
                <CCarousel controls transition="crossfade" dark interval={false} className="custom-carousel home-mobile">
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0160.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0161.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0162.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0163.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0164.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0165.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0166.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                    <CCarouselItem>
                        <div className='carousel-contain'>
                            <div className='image-div-container'>
                                <img src={require("../../images/Other/IMG-20220919-WA0167.jpg")} alt="image1" />    
                            </div>
                        </div>
                    </CCarouselItem>
                </CCarousel>
            </div>
        </div>
    )
}

export default Design